import Animated from '@/components/animatedComponents/Animated';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import { Dispatch, SetStateAction, useState } from 'react';

interface subNavMenu {
  item: {
    id: string;
    sort: number | null;
    title: string;
    icon: string | null;
    sub_menu_items: {
      sub_menu_item_translations_id: {
        id: string;
        sort: number | null;
        title: string;
        icon: string | null;
        path: string | null;
      };
    }[];
  };
}

interface navCategoryProps {
  clickedCategory: string;
  menuItem: any;
  onCloseDropdown: () => void;
  isReverse: boolean | null;
  selectedSubcategory: number;
  setSelectedSubcategory: Dispatch<SetStateAction<number>>;
}

const MenuItems: React.FC<navCategoryProps> = ({
  menuItem,
  clickedCategory,
  onCloseDropdown,
  isReverse,
  selectedSubcategory,
  setSelectedSubcategory,
}) => {
  return (
    <>
      <div
        className={`flex flex-col w-64 py-6 px-4 overflow-y-scroll no-scrollbar md:max-h-[80vh] transition-transform transform shadow-right`}
      >
        {menuItem?.map((subCat: subNavMenu, index: number) => {
          return (
            <Animated
              key={index}
              delay={index * 0.03}
              vertical={isReverse === null}
              reverse={isReverse as boolean}
              classList="w-56"
            >
              <div className={`flex flex-col w-56`}>
                <div
                  onClick={onCloseDropdown}
                  className="group cursor-pointer"
                  onMouseEnter={() => setSelectedSubcategory(index)}
                >
                  <div
                    className={cn(
                      'text-sm font-proxima_font font-semibold text-black p-3.5 rounded-xl flex items-center justify-between hover:bg-gray',
                      index === selectedSubcategory && 'bg-gray'
                    )}
                  >
                    <span className="text-lg">{subCat?.item?.title}</span>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 256 256"
                      className={cn(
                        'opacity-0 -translate-x-2 group-hover:translate-x-0 group-hover:opacity-100 duration-200',
                        index === selectedSubcategory &&
                          'translate-x-0 opacity-100'
                      )}
                    >
                      <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </Animated>
          );
        })}
      </div>
      {/* List of items in sub-category */}
      <div
        key={selectedSubcategory}
        className="px-4 py-6 grid grid-cols-3 flex-1 h-full"
      >
        {menuItem[selectedSubcategory]?.item?.sub_menu_items?.map(
          (subSubCat: any, index: number) => (
            // <div key={index} className='h-max'>
            <Animated
              key={index}
              delay={index * 0.03}
              reverse={isReverse as boolean}
              classList={cn('h-full')}
            >
              <Link
                href={
                  subSubCat?.sub_menu_item_translations_id?.path ??
                  ('' as string)
                }
                className="flex h-full justify-between group p-3.5 rounded-xl cursor-pointer hover:bg-gray transition-all duration-200"
                onClick={onCloseDropdown}
                prefetch={true}
              >
                <div className="flex group flex-col gap-1">
                  <div className="text-sm font-proxima_font font-semibold text-black">
                    <span className="text-lg">
                      {subSubCat?.sub_menu_item_translations_id?.title}
                    </span>
                  </div>
                  <div className="line-clamp-2 font-medium text-black/60 font-proxima_font">
                    {subSubCat?.sub_menu_item_translations_id?.description}
                  </div>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 256 256"
                  className="w-5 flex-shrink-0 opacity-0 -translate-x-2 group-hover:translate-x-0 group-hover:opacity-100 duration-200"
                >
                  <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
                </svg>
              </Link>
            </Animated>
          )
        )}
      </div>
    </>
  );
};

export default MenuItems;
